import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import MarkLogo from './MarkLogo';
import LoginDrawer from '@/app/user/LoginDrawer';

const LoginRequired = ({ title, message }) => {
  return (
    <div className="text-center">
      <MarkLogo />
      <h1 className="text-3xl mb-4">{title}</h1>
      <span className="block mb-6">{message}</span>
      <LoginDrawer />
      <div className="mt-3">
        <Button variant="ghost" asChild>
          <Link to="/signup">Sign Up</Link>
        </Button>
      </div>
    </div>
  );
};

export default LoginRequired;
